export const TOGGLE_ESTIMATOR = 'TOGGLE_ESTIMATOR';


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/estimator/mutations.js